var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulseChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 12.25V3.5C8.75 2.9564 8.75 2.68461 8.66122 2.4702C8.5428 2.18434 8.31565 1.95722 8.02982 1.83881C7.81538 1.75 7.54361 1.75 7 1.75C6.45639 1.75 6.18462 1.75 5.97018 1.83881C5.68434 1.95722 5.45722 2.18434 5.33881 2.4702C5.25 2.68461 5.25 2.9564 5.25 3.5V12.25H8.75Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.91667 4.66699H8.75V12.2503H9.91667C11.0166 12.2503 11.5666 12.2503 11.9083 11.9086C12.25 11.5669 12.25 11.0169 12.25 9.91699V7.00033C12.25 5.90039 12.25 5.35041 11.9083 5.0087C11.5666 4.66699 11.0166 4.66699 9.91667 4.66699Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.25 7.58301H4.08333C2.98339 7.58301 2.43342 7.58301 2.09171 7.92472C1.75 8.26644 1.75 8.81641 1.75 9.91634C1.75 11.0163 1.75 11.5662 2.09171 11.908C2.43342 12.2497 2.98339 12.2497 4.08333 12.2497H5.25V7.58301Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseChart);
export default __webpack_public_path__ + "static/media/pulse-chart.b3ca4d3a97a8bfc8bc3e53dfe31cbbd5.svg";
export { ForwardRef as ReactComponent };